import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { ApiError } from "../api/client";
import { useTranslation } from "../i18n";

export function ErrorBoundary(){
  const { t } = useTranslation("app");
  const error = useRouteError();

  if (error instanceof ApiError) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-4 p-8 text-center">
        <h1 className="text-2xl font-semibold text-red-400">
          {error.status === 404 ? t("error.notFound") : t("error.somethingWentWrong")}
        </h1>
        <p className="text-slate-400">{error.message}</p>
        <Link to="/" className="text-indigo-400 underline">
          {t("error.backToHome")}
        </Link>
      </div>
    );
  }

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-4 p-8 text-center">
        <h1 className="text-2xl font-semibold text-red-400">
          {error.status} {error.statusText}
        </h1>
        <Link to="/" className="text-indigo-400 underline">
          {t("error.backToHome")}
        </Link>
      </div>
    );
  }

  const errObj = error as Error | null;
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-red-400">{t("error.unexpected")}</h1>
      <p className="text-slate-400">
        {errObj?.message ?? t("error.unknown")}
      </p>
      {errObj?.stack ? (
        <details className="mt-4 max-w-xl text-left text-xs text-slate-500">
          <summary className="cursor-pointer">{t("error.stackTrace")}</summary>
          <pre className="mt-2 overflow-auto rounded bg-slate-900 p-4">{errObj.stack}</pre>
        </details>
      ) : null}
      <Link to="/" className="text-indigo-400 underline">
        {t("error.backToHome")}
      </Link>
    </div>
  );
}
